<template>
  <section class="navbar">
    <div class="navbar__left">
      <a :href="data.navbar.home_link" target="_blank">
        <img
          class="navbar__left--logo"
          :src="require(`../assets/images/${data.navbar.logo}.png`)"
          :alt="data.navbar.logo"
        />
      </a>
    </div>
    <div class="navbar__right">
      <a
        v-if="data.navbar.country_toggle"
        class="navbar__right--toggle"
        :href="data.navbar.country_link"
        target="_blank"
      >
        <img
          :src="require(`../assets/icons/${data.navbar.country_toggle}.svg`)"
          :alt="data.navbar.country_toggle"
        />
      </a>
      <a class="navbar__right--button" :href="data.download" target="_blank">
        <img class="icon" src="../assets/images/download.svg" alt="download" />
        {{ data.navbar.button_text }}
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.navbar {
  margin-bottom: -10px;
  background-color: var(--color-orange-1);
  padding: 20px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__left {
    display: flex;
    align-items: flex-end;
    &:hover {
      transform: scale(1.02);
    }
    @media (max-width: $tablet) {
      flex-direction: column;
      width: 60%;
      align-items: flex-start;
    }
    &--logo {
      width: 250px;
      padding: 0 10px 0 0;
      margin: 0;
      @media (max-width: $tablet) {
        width: 150px;
        padding: 0;
      }
    }
    &--title {
      color: var(--color-white-1);
      font-weight: 600;
      @media (max-width: $tablet) {
        flex-direction: column;
        padding: 10px 0;
      }
    }
  }
  &__right {
    display: flex;
    align-items: self-start;
    &--button {
      padding: 8px;
      background-color: transparent;
      border: 2px solid var(--color-white-1);
      border-radius: 30px;
      cursor: pointer;
      color: var(--color-white-1);
      text-decoration: none;
      display: flex;
      max-width: 200px;
      justify-content: space-evenly;
      align-items: center;
      img {
        margin-right: 2px;
      }
      &:hover {
        transform: scale(1.02);
      }
    }
    &--toggle {
      margin: 0 20px 0 0;
      padding: 0;
      &:hover {
        transform: scale(1.02);
      }
      img {
        width: 50px;
        border-radius: 30px;
        border: 2px solid var(--color-white-1);
      }
    }
  }
}
</style>